export default __webpack_public_path__ + "36b9eeaeec97ba159ac50cbef3999642.svg";